// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Counter_wrapper__dqVHX","button":"Counter_button__1Xg-V","decrease":"Counter_decrease__19znl","increase":"Counter_increase__rzNdX","value":"Counter_value__3i7KR"};